import React from 'react'
import { DatePicker, Form, Input, Select, Switch, TimePicker } from 'antd';
import { Grid } from '@mui/material';
import TextArea from 'antd/lib/input/TextArea';

const inputStyle = {
    padding: "10px",
    // border: "none",
    borderRadius: "8px"
}



const DynamicFormFieldsAntd = ({ fields, formList, formListKey, form }) => {
    let setProps = {
        formListKey,
        formList
    }
    return <>
        {
            fields?.map((x, i) => <ShowInput key={i} data={x} formListKey={formListKey} formList={formList} form={form} />)
        }
    </>
}



const ShowInput = ({ data, formList, formListKey, form }) => {

    let Component = {
        1: <TextComponent data={data} />,
        2: <DatePickerComponent data={data} />,
        3: <DropDownComponent data={data} />,
        4: <TimeComponent data={data} />,
        5: <TextAreaComponent data={data} />,
        6: <NumberComponent data={data} />,
        7: <RadioButton data={data} form={form} />,
        8: <AnyButton data={data} form={form} />,
        9: <Empty data={data} form={form} />,
        // 9: <FormList data={data} formListKey={formListKey} formList={formList} />
    }
    return Component[data?.type]
}



export default DynamicFormFieldsAntd
// export const DropDownOptionsFormatAntd = (array, id, title) => {
//     return array?.map(x => { return { id: x?.[`${id}`], title: x?.[`${title}`] } }) || []
// }


const Label = ({ text }) => {
    return <Grid xs={12} className={`mbold`} style={{ marginBottom: '10px', fontWeight: '800' }}>{text}</Grid>
}
const TextComponent = ({ data }) => {
    let { label, typography = false, keyName, isRequired = false, validation, placeholder, isDisabled, width = "100%" } = data
    return <div style={{ display: "flex", flexDirection: "column" }}>
        <Label text={label} />
        <Form.Item
            name={keyName}
            rules={[
                {
                    required: isRequired,
                    message: <span style={{ fontSize: "10px", color: "red" }}>Please fill this field!</span>,
                },
                validation && {
                    pattern: validation,
                    message: <span style={{ fontSize: "10px", color: "red" }}>Invalid input!</span>
                }
            ]}
        >
            <Input placeholder={label} disabled={isDisabled} style={{ ...inputStyle, width: width }} />
        </Form.Item>
        {typography && <span style={{ fontSize: "10px", color: "lightgray" }}>{typography} </span>}
    </div>
}
const DatePickerComponent = ({ data }) => {
    let { label, typography = false, keyName, isRequired = false, validation = false, placeholder, isDisabled = false, width = "100%" } = data
    return <div style={{ display: "flex", flexDirection: "column" }}>
        <Label text={label} />
        <Form.Item name={keyName}
            rules={[
                {
                    required: isRequired,
                    message: <span style={{ fontSize: "10px", color: "red" }}>Please fill this field!</span>,
                },
            ]}>
            <DatePicker format={"MM-DD-YYYY"} disabled={isDisabled} style={{ ...inputStyle, width: width }} />
        </Form.Item>
        {typography && <span style={{ fontSize: "10px", color: "lightgray" }}>{typography} </span>}
    </div>
}
const DropDownComponent = ({ data }) => {
    let { label, typography = false, keyName, isRequired = false, validation, placeholder, isDisabled = false, options, onChange = () => { }, key = "id", width = "100%" } = data
    const filterOption = (input, option) => (option?.children ?? '').toLowerCase().includes(input.toLowerCase());

    return <div style={{ display: "flex", flexDirection: "column" }}>
        <Label text={label} />
        <Form.Item
            name={keyName}
            rules={[
                {
                    required: isRequired,
                    message: <span style={{ fontSize: "10px", color: "red" }}>Please fill this field!</span>,
                },
            ]}
        >
            <Select
                placeholder={label}
                disabled={isDisabled}
                onChange={onChange}
                style={{ width: width }}
                optionFilterProp="children"
                showSearch
                className='custom-dropdown'

                filterOption={filterOption}>
                {options?.map(x =>
                    <Select.Option  value={key === "id" ? x?.id : key === "code" ? x?.code : x?.title}>{x?.title}</Select.Option>
                )}
            </Select>
        </Form.Item>
        {typography && <span style={{ fontSize: "10px", color: "lightgray" }}>{typography} </span>}
    </div >
}
const TimeComponent = ({ data }) => {
    let { label, typography = false, keyName, isRequired = false, validation, placeholder, isDisabled = false, width = "100%" } = data

    return <div style={{ display: "flex", flexDirection: "column" }}>
        <Label text={label} />
        <Form.Item
            name={keyName}
            rules={[
                {
                    required: isRequired,
                    message: <span style={{ fontSize: "10px", color: "red" }}>Please fill this field!</span>,
                },
            ]}>
            <TimePicker disabled={isDisabled} use12Hours={true} style={{ ...inputStyle, width: width }} format={"HH:mm a"} />
        </Form.Item>
        {typography && <span style={{ fontSize: "10px", color: "lightgray" }}>{typography} </span>}
    </div>
}
const TextAreaComponent = ({ data }) => {
    let { label, typography = false, keyName, isRequired = false, validation, placeholder, isDisabled = false, rows, width = "100%", page = ""
    } = data
    return <div style={{ display: "flex", flexDirection: "column", gridRowStart: page === "createTicket" ? "span 2" : "" }}>
        <Label text={label} />
        <Form.Item
            name={keyName}
            rules={[
                {
                    required: isRequired,
                    message: <span style={{ fontSize: "10px", color: "red" }}>Please fill this field!</span>,
                },
                {
                    max: 1000,
                    message: <span style={{ fontSize: "10px", color: "red" }}>Maximum characters allowed: 1000</span>,
                }
            ]}>
            <TextArea rows={rows} placeholder={label} disabled={isDisabled} style={{ ...inputStyle, width: width }} />
        </Form.Item>
        {typography && <span style={{ fontSize: "10px", color: "lightgray" }}>{typography} </span>}
    </div>
}
const NumberComponent = ({ data, form }) => {
    let { label, typography = false, keyName, isRequired = false, validation = false, placeholder, isDisabled = false, width = "100%" } = data
    return <div style={{ display: "flex", flexDirection: "column" }}>
        <Label text={label} />
        <Form.Item
            name={keyName}
            rules={[
                {
                    required: isRequired,
                    message: <span style={{ fontSize: "10px", color: "red" }}>Please fill this field!</span>,
                },
                validation && {
                    pattern: validation,
                    message: <span style={{ fontSize: "10px", color: "red" }}>Invalid input!</span>
                }
            ]}
        >
            <Input type='number' placeholder={label} disabled={isDisabled} style={{ ...inputStyle, width: width }} onWheel={(e) => e.target.blur()} />
        </Form.Item>
        {typography && <span style={{ fontSize: "10px", color: "lightgray" }}>{typography} </span>}
    </div>
}
const RadioButton = ({ data, form }) => {
    let { label, typography = false, keyName, isRequired = false, validation, placeholder, isDisabled = false, isChecked, onChange = () => { } } = data
    return <div style={{ display: "flex", flexDirection: "column" }}>
        <Label text={label} />
        <Form.Item
            name={keyName}
            rules={[
                {
                    required: isRequired,
                    message: <span style={{ fontSize: "10px", color: "red" }}>Please fill this field!</span>,
                },
            ]}>
            <Switch defaultChecked={form ? form?.getFieldValue(keyName) : undefined} onChange={onChange} disabled={isDisabled} />
        </Form.Item>
        {typography && <span style={{ fontSize: "10px", color: "lightgray" }}>{typography} </span>}
    </div>
}


const AnyButton = ({ data, form }) => {
    let { onClick, label } = data
    return <span onClick={onClick} style={{ background: "lightgray", height: "45px", borderRadius: "5px", cursor: "pointer", marginTop: "30px", display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>{label}</span>
}

const Empty = ({ data }) => {
    return <></>
}